import { connect } from 'react-redux';

import { bindActionCreators } from 'redux';

import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { changeJourneyParam } from '@store/yourJourney/actions';

import { entitySelectors } from '@store/entity/selectors';
import { SpaDays } from './SpaDays';

const mapStateToProps = (state) => {
  const journeyParams = yourJourneySelectors.getParsedJourneyParams(state);
  return {
    property: entitySelectors.getProperty(state),
    journeyParams,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeJourneyParam,
    },
    dispatch
  );

export const SpaDaysConnected: any = connect(mapStateToProps, mapDispatchToProps)(SpaDays);
